import { render, staticRenderFns } from "./CoursePanel.vue?vue&type=template&id=1b2ecaca&scoped=true"
import script from "./CoursePanel.vue?vue&type=script&lang=js"
export * from "./CoursePanel.vue?vue&type=script&lang=js"
import style0 from "./CoursePanel.vue?vue&type=style&index=0&id=1b2ecaca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ecaca",
  null
  
)

export default component.exports